import utils from '../../Shared/utils.jsx';

/**
 * Discover page SFCs under Application/pages/ and register them on utils.nativePages.
 * Component id = filename stem (NativeVueDemo.vue → NativeVueDemo).
 * Paths containing /components/ are skipped (page-private helpers).
 */
export function registerNativePages() {
    const modules = import.meta.glob('./**/*.vue');

    for (const path of Object.keys(modules)) {
        const normalized = path.replace(/\\/g, '/');
        if (normalized.includes('/components/'))
            continue;

        const fileName = normalized.split('/').pop() || '';
        if (!fileName.endsWith('.vue'))
            continue;

        const componentId = fileName.slice(0, -'.vue'.length);
        if (!componentId)
            continue;

        utils.nativePages[componentId] = modules[path];
    }
}
